// @flow
import * as React from 'react';
import styled, {keyframes} from 'styled-components';
import Image, {BackgroundImage} from 'components/Image'
import {
  LayoutColumn,
  LayoutInline,
  //useLayoutState
} from 'components/Layout';
import {LocalizedParagraph, useLocalized} from 'components/Localized';
import {IsMobileAgent, IsTouchAgent, IsNonTouchAgent, isTouch} from 'components/Responsive';
import GuideMessage from './GuideMessage';
import Disclaimer from 'components/Disclaimer'
import ButtonNextPage from 'components/ButtonNextPage';
import Space from 'components/Space';
import * as AudioUtils from 'utils/audioUtils';
import SoundToggleButton from 'components/SoundToggleButton';

type Props = {
  onNext: () => void,
  isHidden: boolean,
};

export default function Chapter2(props: Props): React.Element<any> {
  //const layoutState = useLayoutState();
  const localized = useLocalized();

  React.useEffect(()=>{
    AudioUtils.playBGM_racing();
    return ()=>{
    };
  }, []);

  React.useEffect(()=>{
    window.tagManager.drivingZoneCourseAHowToPlayPage();
  },[]);

  return (
    <Wrapper isHidden={props.isHidden}>
      <GuideWrapper>
        <div>
          <GuideMessage in={true} timeout={300} guide={localized.driving_a00_guide_004} />
        </div>
      <LayoutInline>
        <GuideKeyMobile source="./driving-zone/img-guide-mobile-bg.png">
          <IsTouchAgent>
          <GuideKeyHand source="./driving-zone/img-guide-03.png" datawidth={375} dataheight={134} datax={-39} datay={93} dataanimation={fadeIn1} />
          <GuideKeyHand source="./driving-zone/img-guide-04.png" datawidth={375} dataheight={134} datax={-39} datay={93} dataanimation={fadeIn2} />
          <GuideKeyHand source="./driving-zone/img-guide-01.png" datawidth={375} dataheight={134} datax={-39} datay={93} dataanimation={fadeIn3} />
          <GuideKeyHand source="./driving-zone/img-guide-02.png" datawidth={375} dataheight={134} datax={-39} datay={93} dataanimation={fadeIn4} />
          <GuideKeyHand source="./driving-zone/img-guide-05.png" datawidth={454} dataheight={134} datax={-39} datay={93} dataanimation={fadeIn5} />
          <GuideKeyHand source="./driving-zone/img-guide-06.png" datawidth={454} dataheight={134} datax={-39} datay={93} dataanimation={fadeIn6} />
          </IsTouchAgent>
          <IsNonTouchAgent>
            <GuideKeyDesktopBase datawidth={undefined} dataheight={64} datax={64} datay={264}>
              <Image source="./driving-zone/img-key-a-off.png" />
              <Space widthD={10} />
              <Image source="./driving-zone/img-key-s.png" />
              <Space widthD={10} />
              <Image source="./driving-zone/img-key-d-off.png" />
              <Space widthD={159} />
              <Image source="./driving-zone/img-key-space-off.png" />
            </GuideKeyDesktopBase>
            <GuideKeyDesktop datawidth={340} dataheight={64} datax={64} datay={264} dataanimation={fadeIn1}>
              <Image source="./driving-zone/img-key-a-off.png" />
              <Space widthD={84} />
              <Image source="./driving-zone/img-key-d-off.png" />
            </GuideKeyDesktop>
            <GuideKeyDesktop datawidth={340} dataheight={64} datax={64} datay={264} dataanimation={fadeIn2}>
              <Image source="./driving-zone/img-key-a-on.png" />
              <Space widthD={84} />
              <Image source="./driving-zone/img-key-d-off.png" />
            </GuideKeyDesktop>
            <GuideKeyDesktop datawidth={340} dataheight={64} datax={64} datay={264} dataanimation={fadeIn3}>
              <Image source="./driving-zone/img-key-a-off.png" />
              <Space widthD={84} />
              <Image source="./driving-zone/img-key-d-off.png" />
            </GuideKeyDesktop>
            <GuideKeyDesktop datawidth={340} dataheight={64} datax={64} datay={264} dataanimation={fadeIn4}>
              <Image source="./driving-zone/img-key-a-off.png" />
              <Space widthD={84} />
              <Image source="./driving-zone/img-key-d-on.png" />
            </GuideKeyDesktop>
            <GuideKeyDesktop datawidth={250} dataheight={64} datax={435} datay={264} dataanimation={fadeIn5}>
              <Image source="./driving-zone/img-key-space-off.png" />
            </GuideKeyDesktop>
            <GuideKeyDesktop datawidth={340} dataheight={64} datax={64} datay={264} dataanimation={fadeIn6}>
              <Image source="./driving-zone/img-key-a-on.png" />
              <Space widthD={84} />
              <Image source="./driving-zone/img-key-d-off.png" />
            </GuideKeyDesktop>
            <GuideKeyDesktop datawidth={250} dataheight={64} datax={435} datay={264} dataanimation={fadeIn6}>
              <Image source="./driving-zone/img-key-space-on.png" />
            </GuideKeyDesktop>
          </IsNonTouchAgent>
          <GuideKeyCar source="./driving-zone/img-guide-car-1.png" datawidth={isTouch() ? 72 : 144} dataheight={isTouch() ? 61 : 122} datax={isTouch() ? 150 : 346} datay={isTouch() ? 46 : 112} dataanimation={isTouch() ? leftRight : leftRightD} />
          <GuideKeyCar source="./driving-zone/img-guide-car-2.png" datawidth={isTouch() ? 138 : 276} dataheight={isTouch() ? 109 : 218} datax={isTouch() ? 143 : 332} datay={isTouch() ? 49 : 97} dataanimation={isTouch() ? drift : driftD} />
          <IsMobileAgent>
            <GuideKeyMessage {...localized.driving_a00_guide3_003} datawidth={172} datax={0} datay={90} />
            <GuideKeyMessage {...localized.driving_a00_guide3_004} datawidth={113} datax={258} datay={90} />
          </IsMobileAgent>
          <IsNonTouchAgent>
            <GuideKeyMessage {...localized.driving_a00_guide3_210307_001} datawidth={340} datax={0} datay={229} />
            <GuideKeyMessage {...localized.driving_a00_guide3_210307_002} datawidth={360} datax={380} datay={229} />
          </IsNonTouchAgent>
        </GuideKeyMobile>
      </LayoutInline>
      <div />
      </GuideWrapper>
      <ButtonNextPage
        title={localized.driving_a00_guide3_ok}
        onNext={props.onNext}
      />
      <SoundToggleButton />
      <Disclaimer textKey="disclaimer_driving" />
    </Wrapper>
  );
}


const Wrapper = styled.div`
  width:100%;
  height: 100%;
  opacity: ${props => props.isHidden ? 0 : 1};
`;

const GuideWrapper = styled(LayoutColumn)`
  height: 100%;
  >:nth-child(1) {
    flex:1;
    display: flex;
    align-items: center;
    justify-content: center;
    > div {
      margin-top: ${props => props.theme.layout.mobile || isTouch() ? 0 : 80}px;
    }
  }
  >:nth-child(2) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >:nth-child(3) {
    flex:1;
  }
`;

const fadeIn1 = keyframes`
  0% {
    opacity: 0;
  }
  8% {
    opacity: 1;
  }
  16% {
    opacity: 0;
  }
`;

const fadeIn2 = keyframes`
  8% {
    opacity: 0;
  }
  16% {
    opacity: 1;
  }
  40% {
    opacity: 0;
  }
`;

const fadeIn3 = keyframes`
  24% {
    opacity: 0;
  }
  32% {
    opacity: 1;
  }
  40% {
    opacity: 0;
  }
`;

const fadeIn4 = keyframes`
  32% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  64% {
    opacity: 0;
  }
`;

const fadeIn5 = keyframes`
  56% {
    opacity: 0;
  }
  64% {
    opacity: 1;
  }
  72% {
    opacity: 0;
  }
`;

const fadeIn6 = keyframes`
  64% {
    opacity: 0;
  }
  72% {
    opacity: 1;
  }
  96% {
    opacity: 0;
  }
`;


const leftRight = keyframes`
  0% {
    opacity: 1;
  }
  8% {
    transform: translateX(0px)
  }
  32% {
    transform: translateX(-50px)
  }
  40% {
    transform: translateX(-50px)
  }
  64% {
    opacity: 1;
    transform: translateX(0px)
  }
  72% {
    opacity: 0;
  }
  96% {
  }
`;

const leftRightD = keyframes`
  0% {
    opacity: 1;
  }
  8% {
    transform: translateX(0px)
  }
  32% {
    transform: translateX(-100px)
  }
  40% {
    transform: translateX(-100px)
  }
  64% {
    opacity: 1;
    transform: translateX(0px)
  }
  72% {
    opacity: 0;
  }
  96% {
  }
`;

const drift = keyframes`
  0% {
    opacity: 0;
  }
  8% {
  }
  32% {
  }
  40% {
  }
  64% {
    opacity: 0;
  }
  72% {
    opacity: 1;
    transform: translateX(0px)
  }
  96% {
    opacity: 1;
    transform: translateX(-25px)
  }
  to {
    opacity: 0;
    transform: translateX(-25px)
  }
`;

const driftD = keyframes`
  0% {
    opacity: 0;
  }
  8% {
  }
  32% {
  }
  40% {
  }
  64% {
    opacity: 0;
  }
  72% {
    opacity: 1;
    transform: translateX(0px)
  }
  96% {
    opacity: 1;
    transform: translateX(-50px)
  }
  to {
    opacity: 0;
    transform: translateX(-50px)
  }
`;

const GuideKeyMobile = styled(BackgroundImage)`
  width: ${(props) => (isTouch() ? 370 : 740)}px;
  height: ${(props) => (isTouch() ? 180 : 360)}px;
  position: relative;
`;

const GuideKeyHand = styled(BackgroundImage)`
  width: ${props => props.datawidth}px;
  height: ${props => props.dataheight}px;
  position: absolute;
  left: ${props => props.datax}px;
  top: ${props => props.datay}px;
  opacity: 0;

  animation-name: ${props => props.dataanimation};
  animation-duration: 6s;
  animation-iteration-count: infinite;
`;

const GuideKeyDesktop = styled.div`
  width: ${props => props.datawidth}px;
  height: ${props => props.dataheight}px;
  position: absolute;
  left: ${props => props.datax}px;
  top: ${props => props.datay}px;
  opacity: 0;

  animation-name: ${props => props.dataanimation};
  animation-duration: 6s;
  animation-iteration-count: infinite;

  display: flex;
`;

const GuideKeyDesktopBase = styled.div`
  width: ${props => props.datawidth}px;
  height: ${props => props.dataheight}px;
  position: absolute;
  left: ${props => props.datax}px;
  top: ${props => props.datay}px;

  display: flex;
`;

const GuideKeyCar = styled(BackgroundImage)`
  width: ${props => props.datawidth}px;
  height: ${props => props.dataheight}px;
  position: absolute;
  left: ${props => props.datax}px;
  top: ${props => props.datay}px;
  opacity: 0;

  animation-name: ${props => props.dataanimation};
  animation-duration: 6s;
  animation-iteration-count: infinite;
`;

const GuideKeyMessage = styled(LocalizedParagraph)`
  position: absolute;
  width: ${props => props.datawidth}px;
  text-align: center;
  left: ${props => props.datax}px;
  top: ${props => props.datay}px;
`;
